import {
    FETCH_WEBSITE,
    SAVE_WEBSITE,
} from '../../actions/types';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_WEBSITE:
            return action.payload;
        case SAVE_WEBSITE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
